<template>
  <div class="d2c-journey__container app-container--width-max">
    <div class="no-quote-container pt-7 mb-10 mx-xl-0">
      <div class="px-4 px-xl-10">
        <BaseButton
          text="Back to 'Your cover'"
          flat
          ripple
          class="font-weight-bold d-flex back-btn ml-lg-n9 back-previous__btn-link mt-1"
          icon="mdi-chevron-left"
          color="#106175"
          small
          @click="$emit('backToYourCover')"
        />
        <h2
          class="font-weight-bold mt-5 mb-4 mb-xl-10 pl-xl-5 font-28 section-title"
        >
          {{
            $vuetify.breakpoint.mdAndDown
              ? "Your quote"
              : "Your Landlord’s Insurance quote"
          }}
        </h2>
      </div>

      <v-divider class="mx-xl-10"></v-divider>
      <div class="text-center info__wrapper pb-0">
        <h3
          class="font-weight-bold mb-9"
          :class="$vuetify.breakpoint.lgAndUp ? 'font-24' : 'font-28'"
        >
          Sorry!
        </h3>
        <p class="font-weight-regular mb-9 px-0 px-lg-10">
          Unfortunately, we were unable to provide you with a quote for the
          cover options you have chosen. Please click the customise button below
          to review your chosen cover levels and optional extras.
        </p>
        <BaseButton
          :text="'CUSTOMISE'"
          height="60"
          :minWidth="$vuetify.breakpoint.lgAndUp ? '520' : '100%'"
          :block="$vuetify.breakpoint.lgAndUp ? false : true"
          :color="'#106175'"
          class="font-weight-bold font-20 rounded-pill px-10 white--text btn-quote"
          @click="$emit('customiseQuote')"
        />
      </div>
      <div class="px-0 px-lg-10">
        <v-divider class="mt-10 mt-lg-16"></v-divider>
      </div>
      <div class="text-center info__wrapper pt-0">
        <h3
          class="font-weight-bold mb-9 mt-9 mt-lg-14"
          :class="$vuetify.breakpoint.lgAndUp ? 'font-24' : 'font-28'"
        >
          Contact us
        </h3>

        <p class="font-weight-regular mb-9 px-0 px-lg-10">
          Alternatively, you can contact us to speak to a member of our team who
          may be able to assist you. Please call us on the number below.
        </p>
        <h3 class="font-32 text--gray-dark mb-8 font-weight-semi-bold">
          {{ contactInfo?.PhoneNumber }}
        </h3>
        <div>
          <p class="mb-0 font-weight-bold">Opening Hours</p>
          <div
            v-for="(itemTime, index) in contactInfo?.BusinessTimes"
            :key="index"
          >
            <p class="mb-0">
              {{ itemTime?.Description }}:
              {{ itemTime?.OpenTime | timeFormat12h }} -
              {{ itemTime?.CloseTime | timeFormat12h }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { QUESTIONS_MODULE } from "@/store/types/module-types";
import BaseButton from "@/components/BaseComponents/BaseButton";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "NoQuoteResultPage",
  components: {
    BaseButton,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(QUESTIONS_MODULE, ["hasQuotes", "contactInfo"]),
  },
  mounted() {
    this.getAppConfigurationContactInfo();
  },
  methods: {
    ...mapActions(QUESTIONS_MODULE, ["getAppConfigurationContactInfo"]),
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/d2c/journey.scss";
.text--gray-dark {
  color: $gray-dark;
}

.no-quote-container {
  .back-btn {
    font-weight: 600 !important;
  }
  background: #fff;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  color: $black-2;
  .info__wrapper {
    padding: 74px 160px 76px;
    color: $black-2;
  }
  :deep(.back-btn) {
    .v-icon {
      margin-right: 0 !important;
    }
  }
}

@media screen and (max-width: ($grid-breakpoints-lg + 1)) {
  .no-quote-container {
    .back-btn {
      margin-left: -15px !important;
    }
    .section-title {
      padding-left: 8px;
    }
    .info__wrapper {
      padding: 74px 40px 96px;
      color: #000;
    }
  }
}
</style>
